// /opt/isp_erp/frontend/src/components/ftth/ftthIcons.js
import L from 'leaflet';

// Helper: envuelve un SVG en un divIcon
const svgIcon = (svgString, color = '#000', size = 32) => L.divIcon({
  className: '',
  html: `
    <div style="
      width:${size}px;height:${size}px;
      display:flex;align-items:center;justify-content:center;
      filter: drop-shadow(0 0 2px rgba(0,0,0,.5));
    ">
      ${svgString.replace(/currentColor/g, color)}
    </div>
  `,
  iconSize: [size, size],
  iconAnchor: [size / 2, size / 2],
  popupAnchor: [0, -size / 2],
});

// --- SVG individuales ---
const SVG_POSTE = `
<svg viewBox="0 0 24 24" width="32" height="32" fill="currentColor">
  <rect x="10" y="2" width="4" height="20" rx="1"/>
  <line x1="6" y1="6" x2="18" y2="6" stroke="currentColor" stroke-width="2"/>
  <line x1="6" y1="10" x2="18" y2="10" stroke="currentColor" stroke-width="2"/>
</svg>`;

const SVG_NAP = `
<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2">
  <rect x="3" y="5" width="18" height="14" rx="2"/>
  <circle cx="7" cy="12" r="1.5" fill="currentColor"/>
  <circle cx="12" cy="12" r="1.5" fill="currentColor"/>
  <circle cx="17" cy="12" r="1.5" fill="currentColor"/>
  <line x1="12" y1="5" x2="12" y2="2" stroke="currentColor"/>
</svg>`;

const SVG_SPLITTER = `
<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2">
  <rect x="3" y="4" width="18" height="16" rx="2"/>
  <path d="M12 8 L7 12 M12 8 L17 12 M12 8 L12 12"/>
  <circle cx="7" cy="14" r="1.5" fill="currentColor"/>
  <circle cx="17" cy="14" r="1.5" fill="currentColor"/>
  <circle cx="12" cy="14" r="1.5" fill="currentColor"/>
</svg>`;

const SVG_OLT = `
<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2">
  <rect x="2" y="6" width="20" height="12" rx="2"/>
  <rect x="5" y="9" width="4" height="6" fill="currentColor"/>
  <circle cx="13" cy="12" r="1.5" fill="currentColor"/>
  <circle cx="17" cy="12" r="1.5" fill="currentColor"/>
  <circle cx="20" cy="12" r="1" fill="currentColor"/>
</svg>`;

const SVG_ODF = `
<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2">
  <rect x="3" y="3" width="18" height="18" rx="1"/>
  <circle cx="7" cy="7" r="1.5" fill="currentColor"/>
  <circle cx="12" cy="7" r="1.5" fill="currentColor"/>
  <circle cx="17" cy="7" r="1.5" fill="currentColor"/>
  <circle cx="7" cy="12" r="1.5" fill="currentColor"/>
  <circle cx="12" cy="12" r="1.5" fill="currentColor"/>
  <circle cx="17" cy="12" r="1.5" fill="currentColor"/>
  <circle cx="7" cy="17" r="1.5" fill="currentColor"/>
  <circle cx="12" cy="17" r="1.5" fill="currentColor"/>
  <circle cx="17" cy="17" r="1.5" fill="currentColor"/>
</svg>`;

const SVG_CAJA = `
<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2">
  <rect x="4" y="6" width="16" height="12" rx="1"/>
  <line x1="4" y1="12" x2="20" y2="12"/>
  <line x1="12" y1="6" x2="12" y2="18"/>
</svg>`;

const SVG_CAMARA = `
<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2">
  <rect x="3" y="8" width="18" height="10" rx="2"/>
  <circle cx="12" cy="13" r="3" fill="currentColor"/>
</svg>`;

const SVG_RESERVA = `
<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="2">
  <circle cx="12" cy="12" r="8"/>
  <circle cx="12" cy="12" r="4" fill="currentColor"/>
</svg>`;

const SVG_DEFAULT = `
<svg viewBox="0 0 24 24" width="32" height="32" fill="currentColor">
  <circle cx="12" cy="12" r="8"/>
</svg>`;

// --- Mapa de íconos por tipo con su color ---
export const ICONS = {
  // Infraestructura
  POSTE: svgIcon(SVG_POSTE, '#795548', 28),
  TORRE: svgIcon(SVG_POSTE, '#5d4037', 32),
  CAMARA: svgIcon(SVG_CAMARA, '#546e7a', 28),
  DUCTO: svgIcon(SVG_CAMARA, '#78909c', 24),

  // Distribución
  NAP: svgIcon(SVG_NAP, '#2196f3', 30),
  CTO: svgIcon(SVG_NAP, '#2196f3', 30),
  CAJA_EMPALME: svgIcon(SVG_CAJA, '#ff5722', 28),
  CAJA_DISTRIBUCION: svgIcon(SVG_CAJA, '#ff9800', 28),

  // Cabecera
  OLT: svgIcon(SVG_OLT, '#e91e63', 34),
  ODF: svgIcon(SVG_ODF, '#9c27b0', 30),
  SPLITTER: svgIcon(SVG_SPLITTER, '#9c27b0', 28),
  SPLITTER_PRIMARIO: svgIcon(SVG_SPLITTER, '#673ab7', 30),
  SPLITTER_SECUNDARIO: svgIcon(SVG_SPLITTER, '#9c27b0', 28),

  // Otros
  RESERVA: svgIcon(SVG_RESERVA, '#607d8b', 24),
  CLIENTE: svgIcon(SVG_DEFAULT, '#4caf50', 22),
  OTRO: svgIcon(SVG_DEFAULT, '#9e9e9e', 22),
};

// Fallback
export const getIcon = (tipo) => ICONS[tipo] || ICONS.OTRO;
